
define('text!templates/drag_drop_helper.html',[],function () { return '<div class="w-DragDropHelper">\n\t{{#isMultiple}}\n\t<div class="content bg1">\n\t\t<div class="label">{{label}}</div>\n\t</div>\n\t{{/isMultiple}}\n\t<div class="content">\n\t\t{{#isMultiple}}\n\t\t<div class="count">{{count}}</div>\n\t\t{{/isMultiple}}\n\t\t<div class="label">{{label}}</div>\n\t</div>\n</div>';});

